import { css } from 'emotion'

export const ModalLayoutStyles = css``
